<template>
	<div>
		<div>
			<Billingcomponent
				:outerVisible="outerVisible"
				@closeouterVisible="closeouterVisible"
				@InvoiceBackInformation="InvoiceBackInformation"
				:title="title"
				:ruleFormb="allitem.ruleFormb"
				:iszhengshu="false"
				:priceall="allitem.priceall"
				:totalall="allitem.totalall"
				:ruleFormbxiao="allitem.ruleFormbxiao"
				:form_chae="allitem.form_chae"
				:bztext="allitem.bztext"
				:stateall="allitem.stateall"
				:listoflists="allitem.listoflists"
				:invoiceNo="allitem.invoiceNo"
				:invoiceCode="allitem.invoiceCode"
				:billingDate="allitem.billingDate"
				:checkCode="allitem.checkCode"
				:HongChongtype="HongChongtype"
			></Billingcomponent>
			<kgdiag
				@closekgdialog="closekgdialog"
				:headtitle="kgtitle"
				:kgdialog="kgdialog"
				:tableDatans="tableDatans"
				:tableDatakp="tableDatakp"
				@openInvoice="getCurrntDocInfo"
				@radiochange="radiochange"
			></kgdiag>

			<!-- 修改自定义说明二修改 -->
			<el-dialog title="修改自定义说明二" :visible.sync="dialogApproval" width="100px;" v-dialogDrag>
				<taxform :Formlist="formlist" ref="taxForm" :formdata="formdata"></taxform>
				<div style="justify-content: center;margin-top: 40px; display: flex;">
					<div class="backstyle" style="margin-right: 30px;margin-left: 30px; margin-bottom: 20px;" @click="dialogApproval = false">返回</div>
					<div class="addstyle" style="margin-bottom: 20px;" @click="submitFrom">提交</div>
				</div>
			</el-dialog>
			<taxSearch :searchdata="searchalllist" :searchlist="searchlist" labelwidth="150px" labelPosition="left" @submitSearch="forshuai"></taxSearch>
			<div class="headline"></div>
			<div class="areacontent" >
				<div class="">
					<div class="Centerupdown">
						<div class="between-line">
							<!-- <el-button type="primary" plain @click="forshuai()" style="width: 100px;">查询</el-button> -->
							<!-- <div class="addstyle" @click="forshuai()" style="width: 100px;margin-right: 10px;"><samp>查询</samp></div> -->
							<!--    <el-button type="primary" plain @click="resetForm()" style="width: 100px;margin-right: 10px;">重置
              </el-button> -->
							<!-- <div class="addstyle" @click="resetForm()" style="width: 100px;margin-right: 10px;"><samp>重置</samp></div> -->
							<el-dropdown style="width: 100px;margin-right: 10px;" v-permission="fpfstk_fspptk_hc">
								<!-- <el-button type="primary"  plain  style="width: 100px; padding-left:30px;"> 红冲
			      <i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i></el-button> -->
								<div class="addstyle" style="width: 100px;margin-right: 10px;">
									<samp>
										红冲
										<i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i>
									</samp>
								</div>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.native="plhc(1)">红冲</el-dropdown-item>
									<el-dropdown-item @click.native="plhc(2)">红冲重开</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<!-- <el-button type="primary" plain style="width: 100px;margin-right: 10px;" @click="excelExport" v-permission='fpfstk_fspptk_dclb'>
			    导出列表
			    <i class="el-icon-thumb el-icon--right"></i>
			  </el-button> -->
							<div class="addstyle" @click="excelExport" style="width: 100px;margin-right: 10px;" v-permission="fpfstk_fspptk_dclb">
								<samp>
									导出列表
									<i class="el-icon-thumb el-icon--right"></i>
								</samp>
							</div>
							<!--  <el-button style="margin-left: 5px;" type="primary" plain @click="openUpdateZidysm2()">
			    修改自定义说明二
			  </el-button> -->
							<div class="addstyle" @click="openUpdateZidysm2()" style="width: 130px;margin-right: 10px;"><samp>修改自定义说明二</samp></div>
						</div>
					</div>
				</div>
				<!--   <div class="end-flex" style="margin-top: 20px">
          <div class="Centerupdown">
            <div class="between-line">
              <el-dropdown style="width: 120px;margin-right: 10px;" v-permission='fpfstk_fspptk_qzhckz'>
                <el-button type="primary"  plain  style="width: 120px; "> 强制红冲控制
                  <i class="el-icon-caret-bottom el-icon--right" ></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="updateRedBluntSign(1)">置为强制红冲</el-dropdown-item>
                  <el-dropdown-item @click.native="updateRedBluntSign(0)">取消强制红冲</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown style="width: 100px;margin-right: 10px;" v-permission='fpfstk_fspptk_hc'>
                <el-button type="primary"  plain  style="width: 100px; padding-left:30px;"> 红冲
                  <i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="plhc(1)">红冲</el-dropdown-item>
                  <el-dropdown-item @click.native="plhc(2)">红冲重开</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button type="primary" plain style="width: 100px;margin-right: 10px;" @click="excelExport" v-permission='fpfstk_fspptk_dclb'>
                导出列表
                <i class="el-icon-thumb el-icon--right"></i>
              </el-button>
            </div>
          </div>
          <div class="Centerupdown">
            <el-button style="margin-left: 5px;" type="primary" plain @click="openUpdateZidysm2()">
              修改自定义说明二
            </el-button>
          </div>
        </div> -->
				<div class="areatable">
					<div class="tableh">
						<template>
							<el-table
								:data="tableData"
								border
								style="width: 100%"
								ref="multipleTable"
								height="calc(100vh - 437px )"
								@selection-change="handleSelectionChange"
								@row-click="selectClick"
								@sort-change="tableSortChange"
							>
								<el-table-column type="selection" width="55" fixed="left"></el-table-column>
								<el-table-column prop="stateall.docNo" align="left" min-width="160px" show-overflow-tooltip label="单据号"></el-table-column>
								<el-table-column label="发票类型" prop="stateall.choosetitleindex" sortable="custom" min-width="100" align="center">
									<template slot-scope="scope">
										<p v-if="scope.row.stateall.choosetitleindex == '026'">电子普票</p>
										<p v-if="scope.row.stateall.choosetitleindex == '028'">电子专票</p>
										<p v-if="scope.row.stateall.choosetitleindex == '007'">纸质普票</p>
										<p v-if="scope.row.stateall.choosetitleindex == '004'">纸质专票</p>
									</template>
								</el-table-column>
								<el-table-column prop="documentStatus" label="发票状态" min-width="100" align="center" key="3">
									<template slot-scope="scope">
										<p v-if="scope.row.documentStatus == '4'" style="color:#FF8000">已开票</p>
										<p v-if="scope.row.documentStatus == '6'" style="color:#FF8000">已红冲</p>
									</template>
								</el-table-column>
								<el-table-column prop="forceRedFlushStatus" label="强制红冲状态" min-width="100" align="center" key="3">
									<template slot-scope="scope">
										<p v-if="scope.row.forceRedFlushStatus != '1'">否</p>
										<p v-if="scope.row.forceRedFlushStatus == '1'">是</p>
									</template>
								</el-table-column>
								<el-table-column prop="invoiceCode" sortable="custom" label="发票代码" min-width="100" align="center"></el-table-column>
								<el-table-column prop="invoiceNo" sortable="custom" label="发票号码" min-width="100" align="center"></el-table-column>

								<el-table-column prop="ruleFormb.customerName" label="购方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
								<el-table-column prop="ruleFormb.taxIdentificationNumber" label="购方税号" align="left" min-width="160px" show-overflow-tooltip>
									<template slot-scope="scope">
										<div>{{ scope.row.ruleFormb.taxIdentificationNumber }}</div>
									</template>
								</el-table-column>
								<el-table-column prop="totalall.pricetotal" label="原金额" align="right" min-width="100">
									<template slot-scope="scope">
										<span>{{ toThousands(Amountformat(scope.row.totalall.pricetotal)) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="totalall.taxtotal" label="原税额" align="right" min-width="100">
									<template slot-scope="scope">
										<span>{{ toThousands(Amountformat(scope.row.totalall.taxtotal)) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="totalall.jiastotal " label="原价税合计" align="right" min-width="100">
									<template slot-scope="scope">
										<span>{{ toThousands(Amountformat(scope.row.totalall.jiastotal)) }}</span>
									</template>
								</el-table-column>
								<el-table-column label="开票日期" align="left" min-width="160px" show-overflow-tooltip>
									<template slot-scope="scope">
										<span>{{ yyyyMMdd(scope.row.billingDate) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="totalall.pricetotal" label="实开金额" align="right" min-width="100">
									<template slot-scope="scope">
										<span>{{ toThousands(Amountformat(scope.row.totalall.yihcje)) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="totalall.taxtotal" label="实开税额" align="right" min-width="100">
									<template slot-scope="scope">
										<span>{{ toThousands(Amountformat(scope.row.totalall.yihcse)) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="totalall.jiastotal " label="实开价税合计" align="right" min-width="100">
									<template slot-scope="scope">
										<span>{{ toThousands(Amountformat(scope.row.totalall.yihcjshj)) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="stateall.zhidr" label="制单人" min-width="100" align="center"></el-table-column>
								<el-table-column prop="zidysm" label="自定义说明" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
								<el-table-column prop="zidysm2" label="自定义说明二" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
								<el-table-column prop="stateall.kaipzddm" label="税盘编号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
								<el-table-column fixed="right" label="操作" min-width="160" align="center">
									<template slot-scope="scope">
										<el-button @click="handleClick(scope.row, '预览原发票')" type="text" size="small" v-permission="fpfstk_fspptk_ckyp">查看原票</el-button>
										<el-button @click.stop="forhongchong(scope.row)" type="text" size="small" style="color: red;" v-permission="fpfstk_fspptk_lbhc">
											红冲
										</el-button>
										<el-button @click.stop="plhcOne(scope.row)" type="text" size="small" v-permission="fpfstk_fspptk_hcck">红冲重开</el-button>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</div>
					<div class="lastend">
						<div>
							当前已勾选
							<span>{{ selectCount }}</span>
							条
						</div>
						<div>
							合计金额
							<span>{{ toThousands(Amountformat(selectJine)) }}</span>
						</div>
						<div>
							合计税额
							<span>{{ toThousands(Amountformat(selectShuie)) }}</span>
						</div>
					</div>
					<div class="buttompage">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:page-sizes="[10, 20, 100, 500]"
							:key="elementui_page_component_key"
							:current-page="currentpage"
							:page-size="pagenum"
							layout="total, sizes, prev, pager, next, jumper"
							:total="totalcount"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import zhuanpiao from './FilloutZhuannegativeinvoice.vue';
import configHttp from '../../../../configHttp';

export default {
	components: {
		zhuanpiao
	},
	data() {
		return {
			searchlist: [
				{
					prop: 'faplxdm',
					label: '发票类型',
					type: 'select',
					selectval: [
						{
							label: '电子普票',
							value: '026'
						},
						{
							label: '纸质普票',
							value: '007'
						},
						{
							label: '全部',
							value: ''
						}
					]
				},	{
					prop: 'faphm',
					label: '发票号码',
					type: 'input'
				},
				{
					prop: 'fapdm',
					label: '发票代码',
					type: 'input'
				},

				{
					prop: 'fpalldate',
					label: '开票日期',
					type: 'date',
					valueformat: 'yyyy-MM-dd'
				},
				{
					prop: 'docNo',
					label: '单 据 号',
					type: 'input'
				},
				{
					prop: 'purchaserName',
					label: '购方名称',
					type: 'input'
				},
				{
					prop: 'purchaserTaxNumber',
					label: '购方税号',
					type: 'input'
				},
				{
					prop: 'kaipzddm',
					label: '税盘编号',
					type: 'input'
				},
				{
					prop: 'yuanHejje',
					label: '原金额',
					type: 'input'
				},
				{
					prop: 'yuanHejse',
					label: '原税额',
					type: 'input'
				},
				{
					prop: 'fapzt',
					label: '单据状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '已开票',
							value: '4'
						},
						{
							label: '已红冲',
							value: '6'
						}
					]
				},
				{
					prop: 'zidysm',
					label: '自定义说明',
					type: 'input'
				},
				{
					prop: 'forceRedFlushStatus',
					label: '强制红冲状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '是',
							value: '1'
						},
						{
							label: '否',
							value: '0'
						}
					]
				}
			],
			checkmeauList: [
				'单据号',
				'发票类型',
				'发票代码',
				'发票号码',
				'购方名称',
				'购方税号',
				'原金额',
				'原税额',
				'原价税合计',
				'开票日期',
				'实开金额',
				'实开税额',
				'实开价税合计',
				'制单人'
			],
			checkHeadFiled: ['danjh', 'faplxdm', 'fapdm', 'faphm', 'goufmc', 'goufsbh', 'hejje', 'hejse', 'jiashj', 'kaiprq', 'yihcje', 'yihcse', 'yihcjshj', 'zhidr'],
			formLabelWidth: '150px',
			cxdialog: false,
			kgdialog: false,
			kgtitle: ['红冲'],
			tableDatans: [{}],
			tableDatakp: [{}],
			isshou: true,
			page: 1,
			kaijuType: '',
			pagenum: 10,
			totalcount: 0,
			serchform: {},
			tableData: [],
			headtitle: ['发票管理', '负数普票填开'],
			cxtitle: ['高级查询'],
			serchval: '',
			title: '',
			allitem: {},
			outerVisible: false,
			chooseitem: {},
			deletecommids: '',
			/* 高级查询搜索条件 */
			searchalllist: {
				docNo: '',
				docStartDate: '',
				docEndDate: '',
				excludeTaxAmount: '',
				includeTaxAmount: '',
				type: '1',
				purchaserName: '',
				purchaserTaxNumber: '',
				reviewer: '',
				issuer: '',
				faplxdm: '',
				payee: '',
				billingStartdate: '',
				billingEnddate: '',
				fpalldate: '',
				Documentstatus_g: '',
				//搜索
				listlikeSearch: '',
				kaipzddm: '',
				forceRedFlushStatus: ''
			},
			serchFormRules: {
				excludeTaxAmount: [{ validator: this.validateHejjeAndHejse, trigger: 'blur' }],
				includeTaxAmount: [{ validator: this.validateHejjeAndHejse, trigger: 'blur' }],
				purchaserTaxNumber: [{ validator: this.validateCustomersbh, trigger: 'blur' }]
			},
			selectCount: '0',
			selectJine: '0.00',
			selectShuie: '0.00',
			selectRow: {},
			selectRows: [],
			HongChongtype: 'pu',
			kaipzddm: '',
			tableHeight: '',
			currentpage: 1,
			elementui_page_component_key: '',
			fpxlxoptions: [
				{
					label: '电子普票',
					value: '026'
				},
				{
					label: '纸质普票',
					value: '007'
				},
				{
					label: '全部',
					value: ''
				}
			],
			choosetitleindex: '0',
			isQuery: false,
			// 红冲类型 ：1、红冲 2、红冲重开
			type: '',
			formlist: [
				{
					prop: 'text',
					label: '修改自定义说明二',
					type: 'textarea',
					isnotnull: true
				}
			],
			formdata: {
				text: ''
			},
			dialogApproval: false,
			sort: '',
			order: ''
		};
	},
	created() {
		// this.getDocList()
	},
	mounted() {
		this.repairtable();
	},
	methods: {
		repairtable() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheightzhengshutiankai();
				setTimeout(() => {
					this.$refs.multipleTable.doLayout();
				}, 300);
				window.onresize = () => {
					this.tableHeight = this.diagheightzhengshutiankai();
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
				};
			});
		},
		plhc(type) {
			this.type = type;
			this.kaijuType = 'batch';
			console.log(this.selectRows);
			if (this.emptyandnull(this.selectRows)) {
				this.$message.error('请选择批量红冲数据');
				return false;
			}
			if (1 == this.selectRows.length) {
				this.forhongchong(this.selectRows[0]);
				return;
			}
			this.$confirm('此操作将进行批量红冲, 是否继续?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// this.getKaipjList().then(res => {
				//
				//   // this.getCurrntDocInfo();
				//   //this.doOneRedLetterBatch();
				//   //this.doRedLetterBatch();
				// });
				this.getCurrntDocInfo();
			});
		},
		plhcOne(row) {
			this.type = '2';
			this.forhongchong(row);
		},
		async doOneRedLetterBatch() {
			let successCount = 0;
			let errorCount = 0;
			let errorMsg = ',其中：';
			for (var i = 0; i < this.selectRows.length; i++) {
				let item = this.selectRows[i];
				let object = {
					id: item.id,
					type: this.type
				};
				let jsonObject = JSON.stringify(object);
				await this.$https.fetchPost('/redLetter/doOneRedLetterBatch', jsonObject).then(res => {
					if (res.data.success) {
						//成功
						successCount++;
					} else {
						// 失败
						errorCount++;
						errorMsg += res.data.message + ';';
					}
				});
				// if (errorCount > 0) {
				//       break;
				// }
			}
			let resultMsg = '共红冲【' + this.selectRows.length + '】张发票，成功【' + successCount + '】条，失败【' + errorCount + '】条 ';
			if (errorCount > 0) {
				resultMsg += errorMsg;
			}
			this.$refs.multipleTable.clearSelection();
			this.selectCount = 0;
			this.selectRows = [];
			this.kgdialog = false;
			this.getDocList();
			this.$message({
				showClose: true,
				message: resultMsg,
				type: errorCount > 0 ? 'error' : 'success'
			});
		},
		doRedLetterBatch() {
			var ids = [];
			this.selectRows.forEach(item => {
				ids.push(item.id);
			});
			this.$https.fetchPost('/redLetter/doRedLetterBatch', ids).then(res => {
				if (res.data.success) {
					this.$refs.multipleTable.clearSelection();
					this.selectCount = 0;
					this.selectRows = [];
					this.kgdialog = false;
					this.getDocList();
				} else {
					this.$refs.multipleTable.clearSelection();
					this.selectCount = 0;
					this.selectRows = [];
					this.kgdialog = false;
					this.getDocList();
					this.$message({
						type: 'error',
						message: res.data.message,
						duration: 10
					});
				}
			});
		},
		handleSelectionChange(e) {
			this.selectCount = 0;
			this.selectJine = 0;
			this.selectShuie = 0;
			let hejje = 0;
			let hejse = 0;
			let count = 0;
			this.selectRows = [];
			e.forEach((item, index) => {
				count++;
				hejje = this.printFn(parseFloat(hejje) + parseFloat(item.totalall.pricetotal));
				hejse = this.printFn(parseFloat(hejse) + parseFloat(item.totalall.taxtotal));
				this.selectRows.push(item);
			});
			this.selectCount = count;
			this.selectJine = hejje;
			this.selectShuie = hejse;
		},
		selectClick(row, column, event) {
			this.$refs.multipleTable.toggleRowSelection(row);
		},
		tableSortChange(column, prop, order) {
			this.order = column.prop;
			if (column.order) {
				this.sort = column.order.replace('ending', '');
			} else {
				this.sort = '';
				this.order = '';
			}
			this.forshuai();
		},
		changeshou() {
			this.isshou = !this.isshou;
		},
		clickchoosetap() {},
		resetForm(formName) {
			Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
			this.searchalllist.type = '1';
		},
		forshuai() {
			/*if(this.emptyandnull(this.searchalllist.faplxdm)){
        this.$message.error("发票类型不能为空")
        return false
      }*/
			this.isQuery = true;
			this.elementui_page_component_key++;
			this.currentpage = 1;
			if (this.searchalllist.fpalldate) {
				this.searchalllist.billingStartdate = this.searchalllist.fpalldate[0];
				this.searchalllist.billingEnddate = this.searchalllist.fpalldate[1];
			}
			this.searchalllist.listlikeSearch = '';
			this.getDocList();
		},
		/* 接口数据 */
		/* 获取开票管理表格区列表数据 */
		getDocList() {
			var newform = JSON.parse(JSON.stringify(this.searchalllist));
			delete newform['fpalldate'];
			this.searchalllist.type = '1';
            newform.fapzl = "1";
			let params = {
				likeSearch: this.searchalllist.listlikeSearch,
				page: this.page,
				limit: this.pagenum,
				sort: this.sort,
				order: this.order,
				search: newform
			};
			if (configHttp.shuangRiTaxNumber) {
				let shuangRiTaxNumber = configHttp.shuangRiTaxNumber;
				let userobj = JSON.parse(localStorage.getItem('useropj'));
				let qiybh = userobj.currCompany.code;
				if (shuangRiTaxNumber.includes(qiybh)) {
					params.search.cank2 = '3';
				}
			}
			this.$https.fetchPost('/invoice/issueInfo/getDocList', params).then(res => {
				this.$nextTick(() => {
					this.tableHeight = this.diagheightzhengshutiankai();
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 500);
					window.onresize = () => {
						this.tableHeight = this.diagheightzhengshutiankai();
						setTimeout(() => {
							this.$refs.multipleTable.doLayout();
						}, 500);
					};
				});
				this.totalcount = res.data.count;
				// console.log(this.total)
				this.tableData = res.data.data;
			});
		},
		/* 开票管理表格区--发票预览 */
		handleClick(row, title) {
			this.HongChongtype = '';
			this.title = title;
			this.title = '预览发票';
			this.allitem = JSON.parse(JSON.stringify(row));
			if ((this.allitem.priceall == null || this.allitem.priceall.length == 0) && this.allitem.listoflists.length > 0) {
				this.allitem.priceall = [{ type: 4 }];
			}
			if (this.allitem.stateall.istaxincluded) {
				this.allitem.priceall.forEach(r => {
					if (r.unitPrice) {
						if (r.quantity && !isNaN(r.taxRate)) {
							r.unitPrice = (r.chooseMoney / (parseFloat(r.taxRate) + 1) / r.quantity).toFixed(15);
						}
						// let charLength = String(r.unitPrice).substring(String(r.unitPrice).lastIndexOf(".")+1).length;
						// if(charLength>15){
						//  r.unitPrice = parseFloat(r.unitPrice).toFixed(15);
						//  let charSuffix = String(r.unitPrice).substring(String(r.unitPrice).lastIndexOf(".")+1);
						//   if(charSuffix == '000000000000000'){
						//         r.unitPrice = parseFloat(r.unitPrice).toFixed(2);
						//    }
						// }
					}
					r.chooseMoney = r.chooseMoney - r.taxRatemoney;
					r.chooseMoney = parseFloat(r.chooseMoney).toFixed(2);
				});
			}
			this.outerVisible = true;
			// 记号记号
		},
		/* 发票返回信息 */
		InvoiceBackInformation(e) {
			let fs = 1;
			var faplxdm = this.selectRows[0].stateall.choosetitleindex;
			var message = '当前发票代码：fapdm，发票号码:faphm，';
			if (fs > 1) {
				message += '开票份数：' + fs + '份，';
			}
			message += '库存kuc份，是否继续开票？';
			let kaipzddm = this.selectRows[0].stateall.kaipzddm;
			let jsonstr = {
				faplxdm: faplxdm,
				kaipzddm: kaipzddm
			};
			faplxdm = JSON.stringify(jsonstr);
			this.$https.fetchPost('/doc/getCurrentInvoiceInfo', faplxdm).then(res => {
				if (res.data.success) {
					var obj = res.data.obj;
					message = message.replace('fapdm', obj.fapdm);
					if (fs > 1) {
						var endfaphm = parseInt(obj.faphm) + parseInt(fs) - 1;
						message = message.replace('faphm', obj.faphm + '-' + endfaphm);
					} else {
						message = message.replace('faphm', obj.faphm);
					}
					message = message.replace('kuc', obj.kuc);

					// this.$confirm(message, '提示', {
					//   confirmButtonText: '确定',
					//   cancelButtonText: '取消',
					//   type: 'warning'
					// }).then(() => {
					//   //  红冲操作
					//   this.doSingleRedLetter(e);
					// }).catch(() => {});

					this.doSingleRedLetter(e);
				}
			});
		},
		doSingleRedLetter(e) {
			//  单张发票红冲
			e.oriInvoiceCode = this.allitem.invoiceCode;
			e.oriInvoiceNo = this.allitem.invoiceNo;
			e.oriDocNo = this.allitem.docNo;
			e.oriBillingDate = this.allitem.billingDate;
			e.invoiceCode = '';
			e.invoiceNo = '';
			e.docNo = '';
			e.ticketMachineCode = this.kaipzddm;
			let params = {
				fapJson: JSON.stringify(e)
			};
			this.$https.fetchPost('/redLetter/doRedLetter', params).then(res => {
				if (res.data.success) {
					this.doBlueLetterReset(e.ruleFormbxiao.docId);
					this.getDocList();
					this.outerVisible = false;
					this.kgdialog = false;
					this.$alert('红冲成功', '红冲结果', {
						confirmButtonText: '确定'
					});
					this.getDocList();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		doBlueLetterReset(id) {
			let type = this.type;
			if (type != 2) {
				return;
			}
			let params = {
				id: id,
				type: 1,
				fplx: 1
			};
			this.$https.fetchPost('/redLetter/doBlueLetterReset', JSON.stringify(params)).then(res => {
				if (res.data.success) {
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 关闭开票弹框 */
		closeouterVisible() {
			this.outerVisible = false;
		},
		forhongchong(row) {
			this.kaijuType = 'single';
			this.selectRow = JSON.parse(JSON.stringify(row));
			this.selectRows = [];
			this.selectRows.push(this.selectRow);
			this.$confirm('此操作将红冲该单据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					/*if (this.selectRow.totalall.pricetotal<0) {
                this.$message.error(this.$tolertJSON['006-5']);
                return;
            }
            if (this.selectRow.documentStatus==='6') {
                this.$message.error(this.$tolertJSON['006-6']);
                return;
            }*/
					// this.$https.fetchPost('/doc/getKaipjList').then(res => {
					//   console.log(JSON.parse(res.data.obj));
					//   this.tableDatakp = JSON.parse(res.data.obj);
					//   this.kgdialog = true;
					// });
					// this.getKaipjList().then(res => {
					//   //  票面信息确认
					//   // this.doRedLetter("编辑发票");
					// });

					this.getCurrntDocInfo();
				})

				.catch(() => {});
		},
		forhongchongck(row) {
			this.kaijuType = 'single';
			this.selectRow = JSON.parse(JSON.stringify(row));
			this.selectRows = [];
			this.selectRows.push(this.selectRow);
			this.$confirm('此操作将红冲重开该单据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.getKaipjList().then(res => {
						//  票面信息确认
						// this.doRedLetter("编辑发票");
					});
				})
				.catch(() => {});
		},
		/* 子传父 */
		closekgdialog(e) {
			this.kgdialog = e;
		},
		/* 筛选 */
		forserchshai() {
			this.cxdialog = false;
		},
		forcloseshai() {
			this.cxdialog = false;
		},
		handleSizeChange(val) {
			this.pagenum = val;
			if (this.totalcount != 0) {
				this.getDocList();
			}
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getDocList();
		},
		getCurrntDocInfo() {
			var faplxdm = this.selectRows[0].stateall.choosetitleindex;
			console.log(faplxdm);
			try {
				this.selectRows.forEach(item => {
					if (faplxdm !== item.stateall.choosetitleindex) {
						throw new Error('只能对相同类型发票进行红冲操作！');
					}
					if (item.documentStatus == '6' && this.kaijuType != 'single') {
						throw new Error('不能对部分红冲的发票进行批量红冲！');
					}
				});
			} catch (err) {
				this.$message.error(err.message);
				return;
			}
			this.getOpenInvoiceMessage(faplxdm, this.selectRows.length);
		},
		getOpenInvoiceMessage(faplxdm, fs) {
			var message = '当前发票代码：fapdm，发票号码:faphm，';
			if (fs > 1) {
				message += '开票份数：' + fs + '份，';
			}
			message += '库存kuc份，是否继续开票？';
			let kaipzddm = this.selectRows[0].stateall.kaipzddm;
			let jsonstr = {
				faplxdm: faplxdm,
				kaipzddm: kaipzddm
			};
			faplxdm = JSON.stringify(jsonstr);
			this.$https.fetchPost('/doc/getCurrentInvoiceInfo', faplxdm).then(res => {
				if (res.data.success) {
					var obj = res.data.obj;
					message = message.replace('fapdm', obj.fapdm);
					if (fs > 1) {
						var endfaphm = parseInt(obj.faphm) + parseInt(fs) - 1;
						message = message.replace('faphm', obj.faphm + '-' + endfaphm);
					} else {
						message = message.replace('faphm', obj.faphm);
					}
					message = message.replace('kuc', obj.kuc);
					this.doOpenInvoiceDialog(message);
				}
			});
		},
		doOpenInvoiceDialog(message) {
			this.$confirm(message, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					switch (this.kaijuType) {
						case 'single':
							this.doRedLetter('编辑发票');
							break;
						case 'batch':
							// this.doRedLetterBatch();
							this.doOneRedLetterBatch();
							break;
					}
				})
				.catch(() => {});
		},
		/* 电专红冲 */
		doRedLetter(title) {
			this.HongChongtype = 'pu';
			this.title = title;
			this.allitem = JSON.parse(JSON.stringify(this.selectRow));
			// this.allitem.priceall.forEach((item, index) => {
			//   if(item.quantity==0){
			//     item.quantity =null;
			//   }else{
			//     item.quantity = -item.quantity;
			//   }
			// });
			// this.allitem=JSON.parse("{\"actualExcludeTaxAmount\":null,\"actualIncludeTaxAmount\":null,\"actualTax\":null,\"applicant\":null,\"applicantEmail\":null,\"applicantPhone\":null,\"billingDate\":\"20220531170724\",\"billingFailReason\":null,\"billingReturnCode\":null,\"billingReturnMessage\":null,\"businessType\":null,\"bztext\":\"\",\"checkCode\":\"81792049900039215957\",\"chuangjrq\":null,\"ciphertext1\":null,\"ciphertext2\":null,\"ciphertext3\":null,\"ciphertext4\":null,\"companyCode\":null,\"createDate\":null,\"documentStatus\":\"4\",\"emailStatus\":null,\"expressBatchNumber\":null,\"expressCompany\":null,\"expressContactNumber\":null,\"form_chae\":{\"chooseMoney\":null,\"kouchu\":\"0\"},\"historyChangeCount\":0,\"id\":27185978,\"imageUploadLogo\":null,\"importBatchNumber\":null,\"invoiceCode\":\"031002100511\",\"invoiceImagePath\":null,\"invoiceNo\":\"49598498\",\"invoicePrintStatus\":null,\"invoiceSource\":null,\"invoiceStatus\":null,\"invoiceType\":null,\"isDirectBill\":\"0\",\"isNegativeInvoice\":null,\"listPrintStatus\":null,\"listoflists\":null,\"machineCode\":null,\"mdh\":null,\"mergerDocumentNo\":null,\"oriBillingDate\":null,\"oriDocNo\":\"S220531aab87a38\",\"oriInvoiceCode\":\"\",\"oriInvoiceNo\":\"\",\"pdfStatus\":\"0\",\"priceall\":[{\"chooseMoney\":\"-408849.56\",\"companyCode\":null,\"companyId\":null,\"docNo\":\"53.097345132743362\",\"goodsCode\":\"\",\"goodsEnglishName\":null,\"goodsName\":\"*饲料*粉状美斯特--蛋氨酸羟基类似物\",\"id\":2266778,\"isEffective\":null,\"itemNo\":null,\"oneTaxRateSign\":\"\",\"quantity\":-7700,\"reference1\":null,\"reference2\":null,\"reference3\":null,\"reference4\":null,\"reference5\":null,\"spec\":\"25公斤/箱\",\"tableSuffix\":null,\"taxCode\":\"1030104020000000000\",\"taxIncentivePolicyDescription\":\"\",\"taxIncentivePolicySign\":\"0\",\"taxItem\":\"1030104020000000000\",\"taxRate\":\"0.13\",\"taxRatemoney\":\"-53150.44\",\"type\":\"2\",\"unit\":\"千克\",\"unitPrice\":\"53.097345132743362\",\"version\":\"0\",\"maxquantity\":7700},{\"chooseMoney\":\"-37168.14\",\"companyCode\":null,\"companyId\":null,\"docNo\":\"\",\"goodsCode\":\"\",\"goodsEnglishName\":null,\"goodsName\":\"*饲料*粉状美斯特--蛋氨酸羟基类似物\",\"id\":2266779,\"isEffective\":null,\"itemNo\":null,\"oneTaxRateSign\":\"\",\"quantity\":null,\"reference1\":null,\"reference2\":null,\"reference3\":null,\"reference4\":null,\"reference5\":null,\"spec\":null,\"tableSuffix\":null,\"taxCode\":\"1030104020000000000\",\"taxIncentivePolicyDescription\":\"\",\"taxIncentivePolicySign\":\"0\",\"taxItem\":\"1030104020000000000\",\"taxRate\":\"0.13\",\"taxRatemoney\":\"-4831.86\",\"type\":\"1\",\"unit\":null,\"unitPrice\":\"\",\"version\":\"0\",\"maxquantity\":null},{},{},{},{},{},{}],\"qrCode\":null,\"receiptNumber\":null,\"redFlushApplicationNumber\":null,\"reportDate\":null,\"reportLog\":null,\"reportStatus\":\"0\",\"returnStatus\":null,\"returnTime\":null,\"ruleFormb\":{\"address\":\"内蒙古通辽市市政府小区3号楼3单元1楼东侧311室\",\"automaticDiscount\":null,\"automaticInvoicing\":null,\"automaticPreMadeInvoice\":null,\"automaticSpecialHandling\":null,\"bank\":\"中国农业银行股份有限公司通辽汇海支行05186101040028518\",\"checklist\":null,\"companyCode\":null,\"companyId\":null,\"customerEnglishName\":null,\"customerInvoiceType\":null,\"customerName\":\"现代牧业（通辽）有限公司\",\"customerNumber\":null,\"customerTaxpayerType\":null,\"isEffective\":null,\"reference1\":null,\"reference2\":null,\"reference3\":null,\"reference4\":null,\"reference5\":null,\"tableSuffix\":null,\"taxIdentificationNumber\":\"911505915554904374\"},\"ruleFormbxiao\":{\"addressPhone\":\"中国（上海）自由贸易试验区美约路81号8幢三层320、340部位 021-61696900\",\"bankAccount\":\"招商银行外高桥保税区支行 218581206710001\",\"bdrawer\":\"葛艳梅\",\"bpayee\":\"金隽豪\",\"breview\":\"彭霖\",\"code\":null,\"docId\":\"27185978\",\"name\":\"安迪苏生命科学制品（上海）有限公司\",\"taxNumber\":\"91310115607413100M\",\"version\":\"8\",\"voider\":null},\"shenqr\":\"\",\"shifqd\":null,\"stateall\":{\"backStatus\":\"\",\"backUrl\":\"\",\"bianmbbbh\":\"\",\"choosetitleindex\":\"026\",\"createDate\":\"20220531170444\",\"createTime\":\"2022年05月31日 17时04分44秒\",\"docDate\":\"20220531170444\",\"docNo\":\"S220531d8d6a03e\",\"erwm\":\"\",\"faply\":\"2\",\"hebdjh\":\"\",\"huicdz\":\"\",\"huiczt\":\"0\",\"isqingdan\":false,\"istaxincluded\":false,\"kaiplx\":\"0\",\"kaipzddm\":\"661937855997\",\"miw\":\"*30050/1>5+7<2651-550*->24+4553020-1-1*7<977461>+17914-4-4-<--041*1--+>6636-45*/+>2424773465<0+1*<+97-417680\",\"ofdUrl\":\"https://skfp.shanghai.chinatax.gov.cn:9008/api?action=getDoc&code=031002100511_49598498_20220531_20F45285&type=3\",\"oriDocNo\":\"S220531aab87a38\",\"qianmz\":\"\",\"returnurl\":null,\"shenqrsj\":\"\",\"shenqryxdz\":\"liuying1@modernfarming.cn\",\"shibxx\":\"\",\"shoupryxdz\":\"\",\"shuiksczt\":\"1\",\"taxpattern\":\"\",\"tspz\":\"0\",\"xinxbbh\":\"\",\"yuankprq\":\"\",\"yuz\":\"\",\"zhidr\":\"shwfedqinhao\",\"zuofr\":\"\",\"zuofrq\":\"\"},\"taxControlNumber\":null,\"taxRate\":null,\"ticketMachineCode\":null,\"totalall\":{\"jiastotal\":\"-420000.00\",\"jiastotalda\":\"（负数）肆拾贰万元整\",\"pricetotal\":\"-371681.42\",\"taxtotal\":\"-48318.58\",\"yihcje\":\"0\",\"yihcjshj\":\"0\",\"yihcse\":\"0\",\"yuanJiastotal\":\"0\",\"yuanPricetotal\":\"0\",\"yuanTaxtotal\":\"0\"},\"userId\":null,\"version\":\"8\",\"voidTime\":null,\"zidysm\":\"\"}");
			console.log(this.allitem);
			var docDetailList = new Array();
			if (this.allitem.priceall == null) {
				this.allitem.priceall = this.allitem.listoflists;
			}
			for (var i = 0; i < this.allitem.priceall.length; i++) {
				var dateil = JSON.parse(JSON.stringify(this.allitem.priceall[i]));
				if (dateil.type === '2') {
					var dateilNext = JSON.parse(JSON.stringify(this.allitem.priceall[i + 1]));
					var jine = parseFloat(dateil.chooseMoney);
					var shuie = parseFloat(dateil.taxRatemoney);
					jine = jine - Math.abs(parseFloat(dateilNext.chooseMoney));
					shuie = shuie - Math.abs(parseFloat(dateilNext.taxRatemoney));
					dateil.chooseMoney = jine;
					dateil.taxRatemoney = shuie;
					dateil.type = '0';
					dateil.unitPrice = dateil.chooseMoney / (dateil.quantity || 1);
					console.log(dateil.unitPrice);
					// 2022.1.19 计算单价最大保留小数点后15位
					let charLength = String(dateil.unitPrice).substring(String(dateil.unitPrice).lastIndexOf('.') + 1).length;
					if (charLength > 15) {
						dateil.unitPrice = parseFloat(dateil.unitPrice.toFixed(15));
					}
					if (dateil.chooseMoney != '' && dateil.chooseMoney != 0) {
						docDetailList.push(dateil);
					}
				} else if (dateil.type != '1') {
					docDetailList.push(dateil);
				}
			}

			this.allitem.priceall = docDetailList;
			this.allitem.priceall.forEach((item, index) => {
				if (item.quantity == 0) {
					item.quantity = null;
				} else {
					item.quantity = -item.quantity;
				}
			});
			this.allitem.bztext = '对应正数发票代码:' + this.allitem.invoiceCode + '号码:' + this.allitem.invoiceNo;
			this.outerVisible = true;
		},
		radiochange(row) {
			this.kaipzddm = row.kaipjbh;
		},
		excelExport() {
			if (this.tableData.length < 1) {
				this.$message.error('数据为空,无法导出');
				return false;
			}
			let url = this.$https.baseURL + 'excel/getDocExcel'; //请求下载文件的地址
			let token = localStorage.getItem('token');
			this.searchalllist.type = '1';
			let param = JSON.parse(JSON.stringify(this.searchalllist));
			var ids = [];
			if (this.selectRows) {
				this.selectRows.forEach(item => {
					ids.push(item.id);
				});
			}
			param.pagenum = this.pagenum;
			param.page = this.page;
			param.serchval = this.serchval;
			if (param.fpalldate) {
				param.fpalldate = param.fpalldate[0] + ',' + param.fpalldate[1];
			}
			param.headTitle = this.checkmeauList;
			param.headFiled = this.checkHeadFiled.toString();
			param.ids = ids;
			if ((token != '') & (token != null)) {
				axios.defaults.headers.common['token'] = token;
			}
			axios
				.post(url, param, { responseType: 'blob' })
				.then(res => {
					if (!res) return;
					let blob = new Blob([res.data], {
						type: 'blob'
					});
					let url = window.URL.createObjectURL(blob);
					let aLink = document.createElement('a');
					aLink.style.display = 'none';
					aLink.href = url;
					aLink.setAttribute('download', '红冲发票.xls'); // 下载的文件
					document.body.appendChild(aLink);
					aLink.click();
					document.body.removeChild(aLink);
					window.URL.revokeObjectURL(url);
					// let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
					// let objectUrl = URL.createObjectURL(blob);
					// window.location.href = objectUrl;
				})
				.catch(error => {
					this.$message.error(error);
				});
		},
		async getKaipjList() {
			//	获取开票机信息
			this.$https.fetchPost('/doc/getKaipjList').then(res => {
				console.log(JSON.parse(res.data.obj));
				this.tableDatakp = JSON.parse(res.data.obj);
				// 选择开票机dialog隐藏
				this.kgdialog = true;
			});
		},
		submitFrom() {
			var param = {};
			var ids = [];
			this.selectRows.forEach(item => {
				ids.push(item.id);
			});
			param.ids = ids;
			param.text = this.formdata.text;

			this.$https.fetchPost('/doc/updateZidysm2', param).then(res => {
				if (res.data.success) {
					this.dialogApproval = false;
					this.getDocList();
				}
			});
		},
		//修改自定义说明二
		openUpdateZidysm2() {
			if (this.selectCount < 1) {
				this.$message({
					type: 'error',
					message: '请选择需要修改自定义说明的单据。'
				});
				return;
			}
			this.dialogApproval = true;
			if (this.$refs.taxform) {
				this.$nextTick(() => {
					this.$refs.taxform.clearValidate();
				});
			}
		}, //强制红冲修改状态
		updateRedBluntSign(state) {
			if (this.selectCount < 1) {
				this.$message({
					type: 'error',
					message: '请选择需要控制红冲的单据。'
				});
				return;
			}
			var message;
			if (state == 1) {
				message = '此操作将发票置为强制红冲状态，红冲时可能存在重复红冲风险，是否继续？';
			} else {
				message = '是否确定取消强制红冲？';
			}
			this.$confirm(message, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					var param = {};
					var ids = new Array();
					var isSuccess = false;
					this.selectRows.forEach(item => {
						if (item.id) {
							ids.push(item.id);
						} else {
							isSuccess = true;
						}
					});
					if (isSuccess) {
						this.$message({
							type: 'error',
							message: '当前有红字申请单未关联到发票，请修改后提交。'
						});
						return;
					}
					param.state = state;
					param.ids = ids;
					this.$https.fetchPost('/doc/updateForceRedFlushStatus', param).then(res => {
						if (res.data.success) {
							this.getDocList();
						}
					});
				})
				.catch(() => {});
		}
	}
};
</script>

<style scoped="scoped" lang="less">
/deep/ .el-input--suffix .el-input__inner {
	padding-right: 15px;
}

.shousuo:extend(.Verticalcenter) {
	height: 20px;
	margin-bottom: 10px;
	background-color: #f8f8f8;
}

.shousuo:hover {
	background: #f8f8f8;
}

.minheight {
	height: 50px;
	overflow: hidden;
	transition: all 0.3s ease;
}

.maxheight {
	height: 200px;
	overflow: hidden;
	transition: all 0.3s ease;
}

.bt1 {
	width: 56px;
	height: 30px;
	border: 1px solid #e5e5e5;
	border-radius: 3px;
	font-size: 14px;
	font-weight: 500;
	color: #2f66fc;
}

.bt2 {
	width: 93px;
	height: 32px;
	background: #2f66fc;
	border-radius: 2px;
	font-size: 15px;
	font-weight: 400;
	cursor: pointer;
	color: #ffffff;
}

.bt3 {
	width: 93px;
	height: 32px;
	background: #e2e2e2;
	border-radius: 2px;
	font-size: 15px;
	font-weight: 400;
	cursor: pointer;
	margin-left: 53px;
	color: #ffffff;
}

/* /deep/.el-dialog__body{
    padding: 0;
} */

/deep/ .el-table--small td {
	padding: 4px 0;
}

/deep/ .el-table__body-wrapper {
	min-height: 160px;
}

/deep/ .el-dialog__body {
	padding: 0px 20px;
}

.areatable {
	margin-top: 16px;
}

.aftericon:extend(.Centerhorizontally) {
	width: 36px;
	height: 33px;
	background: #ffffff;
	box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.09);
	opacity: 1;
	border-radius: 3px;
	margin-left: 20px;
}

.aftericon > img {
	width: 16px;
	height: 16px;
}

.areacontent {
	margin-left: 21px;
}
</style>
